import {Modal, Button, message} from "antd";
import API from "../../../services/API";
import { useState } from "react";

function CancelRefundModal({visible, onCancel, transactionId, userId, refetchUserData}) {
    const [modalLoading, setModalLoading] = useState(false);

    const handleCancelRefund = async () => {
        setModalLoading(true);
        try {
            await API.cancelRefund(userId, transactionId);
            message.success("Successfully canceled refund.");
            refetchUserData();
        } catch (ex) {
            message.error(ex?.response?.data?.error_message || ex?.response?.data?.errorMessage);
        } finally {
            setModalLoading(false);
            onCancel();
        }
    };

    return (
        <Modal
            title="Cancel Refund"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleCancelRefund} loading={modalLoading}>
                    Confirm
                </Button>
            ]}
        >
            <p>Are you sure you want to cancel this refund?</p>
        </Modal>
    );
}

export default CancelRefundModal;